'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_react-slick@0.15.4@react-slick/lib/index.js
// module id = 955
// module chunks = 0 1